import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type AttendancePolicy from 'modules/attendance/store/models/AttendancePolicy'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

interface Props {
  attendancePolicy: AttendanceSetting | AttendancePolicy
  onClose: () => void
}

const DeleteModal = ({ attendancePolicy, onClose }: Props) => {
  const navigate = useNavigate()
  const hasEmployees = attendancePolicy.attributes.employees.length > 0
  const { navigation } = useNavigation()

  const onSubmit = async (closePortal: ClosePortalFn) => {
    if (hasEmployees) return

    navigate(navigation.settings.time_tracking.fullPath())
    await attendancePolicy.destroy()
    closePortal()
  }

  return (
    <Modal
      illustration="delete-cross"
      title={i18n.t('app_store_v2.apps.time_tracking.delete_modal.title')}
      description={i18n.t('app_store_v2.apps.time_tracking.delete_modal.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button type="negative" disabled={hasEmployees} submit>
          {i18n.t('app_store_v2.apps.time_tracking.delete_modal.button')}
        </Button>
      }
    />
  )
}

export default DeleteModal
